import * as tslib_1 from "tslib";
import FocusedInboxHeader from './FocusedInboxHeader';
import MailListHeaderSecondRowTextContent from './MailListHeaderSecondRowTextContent';
import { observer } from 'mobx-react';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { focusedInboxRollupStore } from 'owa-mail-focused-inbox-rollup-store';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { listViewStore } from 'owa-mail-list-store';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import * as React from 'react';
var MailListFolderHeaderSecondRowContent = /** @class */ (function (_super) {
    tslib_1.__extends(MailListFolderHeaderSecondRowContent, _super);
    function MailListFolderHeaderSecondRowContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Render mail list header
        _this.renderMailListHeaderDisplay = function (tableView) {
            // Render F/O header when feature is enabled and user is in Inbox folder
            if (isFocusedInboxEnabled() && tableView.tableQuery.folderId === folderNameToId('inbox')) {
                return (React.createElement(FocusedInboxHeader, { unseenCountToDisplay: focusedInboxRollupStore.unseenCountToDisplay, tableViewId: _this.props.tableViewId }));
            }
            // Render regular folder
            var folder = getSelectedFolder();
            if (!folder) {
                /**
                 * This function gets called when when user switches from a favorite persona to a favorite category. At that time, the selected node
                 * is set to category node while the table is still persona table. Thus we are expecting the folder to be undefined as the category folder
                 * is not saved in folder store.
                 */
                return null;
            }
            return _this.renderHeader(folder.DisplayName);
        };
        _this.renderHeader = function (headerText) {
            return (React.createElement(MailListHeaderSecondRowTextContent, { text: headerText, containerCssClass: _this.props.containerCssClass }));
        };
        return _this;
    }
    MailListFolderHeaderSecondRowContent.prototype.render = function () {
        var tableView = listViewStore.tableViews.get(this.props.tableViewId);
        return this.renderMailListHeaderDisplay(tableView);
    };
    MailListFolderHeaderSecondRowContent = tslib_1.__decorate([
        observer
    ], MailListFolderHeaderSecondRowContent);
    return MailListFolderHeaderSecondRowContent;
}(React.Component));
export default MailListFolderHeaderSecondRowContent;
//# sourceMappingURL=MailListFolderHeaderSecondRowContent.js.map